// Vite does not inject process.env.* like CRA. Static assets in /public are served from root.
// Use import.meta.env.MODE to check environment if needed.
export default function LocalServiceWorkerRegister() {
  const isProd = import.meta.env.MODE === 'production';
  const _root = (function () {
    if (typeof globalThis !== 'undefined') return globalThis;
    try {
      return new Function('return this')();
    } catch (e) {
      if (typeof console !== 'undefined' && typeof console.warn === 'function') {
        console.warn('Unable to resolve global object for service worker registration:', e);
      }
      return {};
    }
  })();

  const isSecure = (_root?.isSecureContext) && location.protocol === 'https:';
  const swPath = '/sw.js'; // Located in public/

  if ('serviceWorker' in navigator && isProd && isSecure) {
  _root?.addEventListener?.('load', () => {
      navigator.serviceWorker.register(swPath)
        .then(registration => {
          console.info('Service worker registered:', registration.scope);
        })
        .catch(err => console.info('Service worker registration failed:', err));
    });
  }
}